<script lang="ts">
	export let data;
	export let max = 5;
</script>

<div class="flex">
	{#if data}
		{#each data.slice(0, max) as keyword}
			<div
				class="w-26 group relative h-8 cursor-pointer rounded-lg border-4 border-white bg-gray-200 px-5"
			>
				{keyword}
			</div>
		{/each}
	{/if}
</div>
